module.exports = __webpack_public_path__ + "img/AI.0dce556d.svg";